import CustomersPage from '@pages/Customers/CustomersPage';
import OrdersPage from '@pages/Orders/OrdersPage';
import CustomerDetailPage from '@pages/Customers/CustomerDetail/CustomerDetailPage';
import AvaPage from '@pages/Ava/AvaPage';
import WebhookPage from '@pages/Webhooks/WebhookPage';
import ProductsPage from '@pages/Products/ProductsPage';
import TemplatesPage from '@pages/Templates/TemplatesPage';
import UsersPage from '@pages/Users/UsersPage';
import ServicesPage from '@pages/Services/ServicesPage';
import CampaignsPage from '@pages/Campaigns/CampaignsPage';

import LoginPage from '@pages/Authentication/LoginPage';
import NotFoundPage from '@pages/NotFoundPage';
import Welcome from '@pages/Welcome/Welcome';
import Restricted from '@pages/Restricted/Restricted';
import SignOut from '@pages/Signout/SignoutPage';

const RouteModules = [
  { path: '/customers', component: <CustomersPage />, module: 'customer', name: 'customerPage', isLandingPage: true },
  { path: '/customer-detail/:id', component: <CustomerDetailPage />, module: 'customer', name: 'customerView' },
  { path: '/orders', component: <OrdersPage />, module: 'customer', name: 'ordersPage' },
  { path: '/products', component: <ProductsPage />, module: 'product', name: 'productsPage', isLandingPage: true },
  { path: '/ava', component: <AvaPage />, module: 'ava', name: 'avaPage', isLandingPage: true },
  { path: '/webhooks', component: <WebhookPage />, module: 'webhook', name: 'webhookPage', isLandingPage: true },
  { path: '/templates', component: <TemplatesPage />, module: 'templates', name: 'templatePage', isLandingPage: true },
  { path: '/users', component: <UsersPage />, module: 'users', name: 'usersPage', isLandingPage: true },
  { path: '/services', component: <ServicesPage />, module: 'services', name: 'servicesPage', isLandingPage: true },
  { path: '/campaigns', component: <CampaignsPage />, module: 'campaign', name: 'campaignsPage', isLandingPage: true },
];

const CommonModules = [
  { path: '/login', component: <LoginPage />, name: 'loginPage' },
  { path: '/welcome', component: <Welcome />, name: 'welcomePage' },
  { path: '/restricted', component: <Restricted />, name: 'restrictedPage' },
  { path: '/signout', component: <SignOut />, name: 'signoutPage' },
  { path: '*', component: <NotFoundPage />, name: 'notFoundPage' },
];

export { RouteModules, CommonModules };
